import { DrawingState, Element, HistoryEntry } from '../types/drawing';

export type HistoryReducerState = Pick<
  DrawingState,
  'elements' | 'history' | 'selectedElements'
>;

export type HistoryAction =
  | { type: 'undo' }
  | { type: 'redo' };

export function applyHistoryAction(
  state: HistoryReducerState,
  action: HistoryAction
): HistoryReducerState {
  switch (action.type) {
    case 'undo': {
      if (state.history.length === 0) return state;
      const lastEntry: HistoryEntry = state.history[state.history.length - 1];
      const newHistory = state.history.slice(0, -1);

      switch (lastEntry.action) {
        case 'add': {
          const elements = state.elements.filter(
            (el) => el.id !== lastEntry.elementId
          );
          return { ...state, elements, history: newHistory };
        }
        case 'delete': {
          const elements: Element[] = [...state.elements, lastEntry.element];
          return { ...state, elements, history: newHistory };
        }
        case 'modify': {
          const elements = state.elements.map((el) =>
            el.id === lastEntry.elementId ? lastEntry.element : el
          );
          return { ...state, elements, history: newHistory };
        }
        case 'clear': {
          const elements = [...lastEntry.elementsSnapshot];
          return { ...state, elements, history: newHistory };
        }
        default:
          return state;
      }
    }
    case 'redo': {
      // Redo not implemented in current store; preserve as no-op
      return state;
    }
    default:
      return state;
  }
}

